import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const Loader = () => (
  <div className="grid min-h-screen place-items-center bg-brand-cream">
    <img src="/panda-mascot.png" alt="Loading" className="h-20 w-20 animate-bounce object-contain" />
  </div>
);

export const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user } = useAuth();
  if (user === null) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/member" replace />;
  return children;
};
